import {Component} from '@angular/core';
import {NzBreadCrumbComponent} from "ng-zorro-antd/breadcrumb";
import {
  NzContentComponent,
  NzFooterComponent,
  NzHeaderComponent,
  NzLayoutComponent,
  NzSiderComponent
} from "ng-zorro-antd/layout";
import {NzIconDirective} from "ng-zorro-antd/icon";
import {NzMenuDirective, NzMenuItemComponent, NzSubMenuComponent} from "ng-zorro-antd/menu";
import {RouterLink, RouterOutlet, Router} from "@angular/router";
import {ShopInfoComponent} from "./shop.info/shop.info.component";
import {NzAffixComponent} from 'ng-zorro-antd/affix';
import {ShopService} from "./shop.info/shop.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    NzBreadCrumbComponent,
    NzContentComponent,
    NzFooterComponent,
    NzHeaderComponent,
    NzIconDirective,
    NzLayoutComponent,
    NzMenuDirective,
    NzMenuItemComponent,
    NzSiderComponent,
    NzSubMenuComponent,
    RouterLink,
    RouterOutlet,
    ShopInfoComponent,
    NzAffixComponent,
    NgIf,
  ],
  templateUrl: './wholesalepos.management.component.html',
  styleUrl: './wholesalepos.management.component.less',
  providers:[
    {provide: ShopService, useClass: ShopService},
  ]
})
export class WholesaleposManagementComponent {
  isCollapsed = false;

  constructor(private router: Router) {}

  goBackToSystemSelection(): void {
    this.router.navigate(['/']).then(() => {}).catch(err => console.error(err));
  }
}
